// Brand colors
export const COLORS = {
  BRAND: {
    BLUE: '#0ea5e9',
    PURPLE_START: '#7c3aed',
    PURPLE_END: '#6d28d9',
    ORANGE_START: '#f97316',
    ORANGE_END: '#ea580c',
  },
  PRIMARY: {
    50: '#f0f9ff',
    100: '#e0f2fe',
    500: '#0ea5e9',
    600: '#0284c7',
    700: '#0369a1',
    800: '#075985',
    900: '#0c4a6e',
  },
  GRAY: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
};

// Animation durations
export const ANIMATIONS = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 600,
  VERY_SLOW: 1000,
};

// Breakpoints
export const BREAKPOINTS = {
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px',
};

// Form validation rules
export const VALIDATION = {
  EMAIL: {
    PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    MESSAGE: 'Please enter a valid email address',
  },
  PASSWORD: {
    MIN_LENGTH: 8,
    PATTERN: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
    MESSAGE:
      'Password must be at least 8 characters with uppercase, lowercase, and number',
  },
  USERNAME: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 20,
    PATTERN: /^[a-zA-Z0-9_]+$/,
    MESSAGE:
      'Username must be 3-20 characters, letters, numbers, and underscores only',
  },
  OTP: {
    LENGTH: 6,
    PATTERN: /^\d{6}$/,
    MESSAGE: 'Please enter a valid 6-digit code',
  },
};

// API endpoints - now centralized in config/api.js
// @deprecated Use API_ENDPOINTS from config/api.js instead
export { API_ENDPOINTS } from '../config/api';

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'imei_checker_token',
  REFRESH_TOKEN: 'imei_checker_refresh_token',
  USER_PREFERENCES: 'imei_checker_preferences',
  THEME: 'imei_checker_theme',
  USER: 'imei_checker_user',
};
